import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { COLOR_WHITE } from '../MaterialWatchman';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    triggerButton: {
        fontSize: '11.5px',
        height: 'auto',
        minWidth: '125px',
        padding: '3.5px 15px',
        '&.MuiButton-outlinedPrimary': {
            border: `1px solid ${theme.palette.primary.dark}`,
            color: theme.palette.primary.dark,
        },
        '&.MuiButton-containedPrimary': {
            border: `1px solid ${theme.palette.primary.dark}`,
            backgroundColor: theme.palette.primary.dark,
            color: COLOR_WHITE,
            boxShadow: 'none',
        },
    },
}));

export default function PopoverTrigger({ buttonDefaultText, buttonActiveText = buttonDefaultText, popoverStyleOverride, dataCy, triggerClassName = '', popoverClassName, children}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <Button className={clsx(classes.triggerButton, triggerClassName)} data-cy={dataCy} aria-describedby={id} variant={open ? 'contained' : 'outlined'} color="primary" onClick={handleClick}>
                {open ? buttonActiveText : buttonDefaultText}
            </Button>
            <Popover
                classes={{ paper: popoverClassName }}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {children}
            </Popover>
        </>
    );
}

PopoverTrigger.propTypes = {
    popoverClassName: PropTypes.string,
    triggerClassName: PropTypes.string,
    buttonDefaultText: PropTypes.string.isRequired,
    buttonActiveText: PropTypes.string,
    popoverStyleOverride: PropTypes.object,
    dataCy: PropTypes.string,
};